/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Standard/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Standard({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/IsAcknowledged/AcknowledgementText/Standard"
  
}) {
  return null
}